import { headerHeight } from '../helpers';

const productSingleContainer = document.querySelector('.template-product');

const stripbarBuy = productSingleContainer?.querySelector('.stripbar__buy');
const productFormBuy = productSingleContainer?.querySelector('.product-single .product__form__bottom');
const productStripbar = productSingleContainer?.querySelector('.product__stripbar');
const productBuy = productSingleContainer?.querySelector('.product__form__submit');
const productTitle = productSingleContainer?.querySelector('.product__meta__title');


function updateStripbar() {

  let productVariant = '';
  productSingleContainer.querySelectorAll('.product__form__option__title--value:not(.sku)').forEach((option, index) => {
    if (index < productSingleContainer.querySelectorAll('.product__form__option__title--value:not(.sku)').length - 1) {
      productVariant = productVariant.concat(option.innerText + ', ');
    } else {
      productVariant = productVariant.concat(option.innerText);
    }
  });

  const productPrice = productSingleContainer.querySelector('#ProductPrice');
  const productComparePrice = productSingleContainer.querySelector('#ComparePrice');
  const productPriceText = productSingleContainer.querySelector('.product__meta__price-info');
  const productMedia = productSingleContainer.querySelector('.product-gallery--thumbnails[active] .product-gallery__grid-thumbnail[data-thumbnail-index="0"]');

  const stripbarTitle = productStripbar?.querySelector('.stripbar__title');
  const stripbarVariant = productStripbar?.querySelector('.stripbar__color');
  const stripbarContainerPrice = productStripbar?.querySelector('.stripbar__price-container');
  const stripbarPrice = productStripbar?.querySelector('.stripbar__price');
  const stripbarComparePrice = productStripbar?.querySelector('.stripbar__compare-price');
  const stripbarPriceText = productStripbar?.querySelector('.stripbar__price-text');
  const stripbarMedia = productStripbar?.querySelector('.stripbar__media');

  if (productTitle && stripbarTitle) {
    const titleContent = productTitle.textContent;
    stripbarTitle.textContent = titleContent;
  }

  if (productVariant && stripbarVariant) {
    stripbarVariant.textContent = productVariant;
  }

  if (productPrice && stripbarPrice) {
    const priceContent = productPrice.textContent;
    stripbarPrice.textContent = priceContent;
  }

  if (productComparePrice && stripbarComparePrice) {
    const priceCompareContent = productComparePrice.textContent;
    stripbarComparePrice.textContent = priceCompareContent;

    if (priceCompareContent.trim() === "") {
      stripbarContainerPrice.classList.remove('stripbar__on-sale');
    } else {
      stripbarContainerPrice.classList.add('stripbar__on-sale');
    }
  }

  if (productPriceText && stripbarPriceText) {
    const priceTextContent = productPriceText.textContent;
    stripbarPriceText.textContent = priceTextContent;
  }

  if (productMedia && stripbarMedia) {
    const mediaContent = productMedia.querySelector('img').getAttribute('srcset');
    stripbarMedia.setAttribute('src', mediaContent);
  }

  if (productBuy && stripbarBuy) {
    const buyContent = productBuy.innerHTML;
    stripbarBuy.innerHTML = buyContent;
  } else {
    const buyContent = document.querySelector('.product__form__bottom').innerHTML;
    stripbarBuy.innerHTML = buyContent;
  }
}

if (productSingleContainer) {

  window.addEventListener("load", () => {
    updateStripbar();
  });

  const options = document.querySelectorAll('.product__form__option');

  if (options.length) {
    options.forEach((option) => {
      option.addEventListener("click", () => {
        setTimeout(() => {
          updateStripbar();
        }, 50);
      });
    })
  }

  const optionTemperature = document.querySelector('.product__form__option--temperature');

  if (optionTemperature) {
    optionTemperature.addEventListener("click", () => {
      setTimeout(() => {
        updateStripbar();
      }, 50);
    });
  }

  if (stripbarBuy) {
    stripbarBuy.addEventListener('click', () => {
      productBuy.querySelector('button').click();
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.target === productFormBuy) {
          if (entry.boundingClientRect.top < 0 && !entry.isIntersecting) {
            productStripbar?.classList.add('visible');
          } else {
            productStripbar?.classList.remove('visible');
          }
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, {
      threshold: [0, 1]
    });

    observer.observe(productFormBuy);
  });

  document.addEventListener('scroll', function () {
    productStripbar.style.top = (headerHeight() + 'px');
  });
}
